import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type FinanceOutboxEventCountsResult = QueryAtomResult<
  typeof financeOutboxEventCountsQueryAtom
>;

export const financeOutboxEventCountsQueryAtom = createQueryAtomFactory(
  'auditLog.financeOutboxEventCounts',
  () => ({
    financeOutboxEventCounts: {
      bill: true,
      invoice: true,
    },
  }),
  {
    select: ({ financeOutboxEventCounts }) => financeOutboxEventCounts,
  },
);
